const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

function fit(box, viewport) {
    const width = clamp(box.width, Math.min(320, viewport.width - 16), viewport.width - 16);
    const height = clamp(box.height, Math.min(220, viewport.height - 16), viewport.height - 16);
    return {width, height, left: clamp(box.left, 8, viewport.width - width - 8), top: clamp(box.top, 8, viewport.height - height - 8)};
}

function change(box, edge, dx, dy, viewport) {
    if (edge === 'move') return fit({...box, left: box.left + dx, top: box.top + dy}, viewport);
    const right = box.left + box.width, bottom = box.top + box.height;
    const minWidth = Math.min(320, viewport.width - 16), minHeight = Math.min(220, viewport.height - 16);
    const left = edge.includes('w') ? clamp(box.left + dx, 8, right - minWidth) : box.left;
    const top = edge.includes('n') ? clamp(box.top + dy, 8, bottom - minHeight) : box.top;
    const nextRight = edge.includes('e') ? clamp(right + dx, left + minWidth, viewport.width - 8) : right;
    const nextBottom = edge.includes('s') ? clamp(bottom + dy, top + minHeight, viewport.height - 8) : bottom;
    return fit({left, top, width: nextRight - left, height: nextBottom - top}, viewport);
}

module.exports = {fit, change};
